// Retain this object for the lifetime of a mutation form. An ambiguous network
// failure can safely retry the same operation without creating a second booking.
export function createRequestKey() {
    let previous = '';
    let key = '';
    return (body: unknown) => {
        const serialized = JSON.stringify(body);
        if (serialized !== previous) {
            const bytes = crypto.getRandomValues(new Uint8Array(16));
            key = Array.from(bytes, value => value.toString(16).padStart(2, '0')).join('');
            previous = serialized;
        }
        return key;
    };
}
